export default "__VITE_ASSET__Nrfd9Kjx__"